import { Alert, AlertTitle, Box, Button, TextField } from "@mui/material";
import { useEffect, useRef, useState, FormEvent } from "react";

import { useInternalLogin } from "../../../hooks/mutations/useInternalLogin";
import { useLogout } from "../../../hooks/mutations/useLogout";
import { useAuth } from "../../../contexts/AppContext";

import logo from "../../../assets/images/logo.png";

import { CustomerSelectModal } from "../../../components/CustomerSelect";

interface ErrorState {
  user: string;
  password: string;
}

const LoginForm = () => {
  const form = useRef<HTMLFormElement>(null);
  const { loggedIn, error: loginError } = useAuth();
  const internalLoginMutation = useInternalLogin();
  const logoutMutation = useLogout();

  const [error, setError] = useState<ErrorState>({
    user: "",
    password: "",
  });
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    logoutMutation.mutate();
    form.current?.reset();
    setOpen(false);
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);

    if (!formData.get("user")) {
      setError(state => ({ ...state, user: "Campo obrigatório" }));
    } else {
      setError(state => ({ ...state, user: "" }));
    }

    if (!formData.get("password")) {
      setError(state => ({ ...state, password: "Campo obrigatório" }));
    } else {
      setError(state => ({ ...state, password: "" }));
    }

    const user = formData.get("user");
    const password = formData.get("password");

    if (user && password) {
      internalLoginMutation.mutate({
        user: user as string,
        password: password as string,
      });
    }
  };

  useEffect(() => {
    if (loggedIn) {
      handleOpen();
    }
  }, [loggedIn]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        {!!loginError && (
          <Box width="100%" maxWidth={800} p={2}>
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {loginError}
            </Alert>
          </Box>
        )}

        <Box
          width="100%"
          p={2}
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Box mr={3} display="flex" alignItems="center">
            <img src={logo} alt="eGAM" width={250} />
          </Box>

          <Box
            component="form"
            noValidate
            autoComplete="off"
            flex={1}
            maxWidth={500}
            onSubmit={handleSubmit}
            ref={form}
          >
            <Box>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="user"
                label="Usuário"
                name="user"
                autoComplete="user"
                autoFocus
                error={!!error.user}
                helperText={error.user}
                onChange={() => setError(state => ({ ...state, user: "" }))}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              <Box mr={3} flex={1}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Senha"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  error={!!error.password}
                  helperText={error.password}
                  onChange={() =>
                    setError(state => ({ ...state, password: "" }))
                  }
                />
              </Box>
              <Box>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Entrar
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <CustomerSelectModal open={open} handleClose={handleClose} isLogin />
    </>
  );
};

export default LoginForm;
